import React from 'react';

interface ConditionalWrapperProps {
  condition: boolean;
  children?: React.ReactNode;
  wrapper: (children: React.ReactNode) => JSX.Element;
  wrapperFalse?: (children: React.ReactNode) => JSX.Element;
}

const ConditionalWrapper = ({
  condition,
  children,
  wrapper,
  wrapperFalse = () => <>{children}</>
}: ConditionalWrapperProps) => (condition ? wrapper(children) : wrapperFalse(children));

export default ConditionalWrapper;
